/**
 * Color palette for accidental bboxes / lighten-mask compositing on
 * noteheads with non-natural alter values. Used both by the live
 * `<FingeringOverlay>` (HTML `<div>` overlay with CSS
 * `mix-blend-mode: lighten`) and by the PDF exporter (canvas pre-
 * composite, then embedded as an image).
 *
 * Color encodes the alter value, not just its sign. This gives
 * the user a quick read on accidental magnitude (single vs. double
 * sharp/flat) without needing to also color the pitch letter. All
 * four colors were picked to stay legible on both filled (black)
 * and hollow (white) noteheads when composited with `lighten`
 * (per-channel `max(backdrop, source)`): black notehead + color →
 * full color, white paper → unchanged.
 *
 *   alter = -2 (♭♭)  → violet
 *   alter = -1 (♭)   → cyan
 *   alter = +1 (♯)   → orange
 *   alter = +2 (𝄪)   → hot pink
 *
 * Out-of-range alters clamp to the nearest extreme so a malformed
 * payload still renders something visually meaningful rather than
 * blowing up.
 */
export const accidentalBboxColor = (alter: number): string => {
  if (alter <= -2) return '#9b4cff';
  if (alter === -1) return '#0077ff';
  if (alter === 1) return '#f06e00';
  return '#ff2d95'; // alter >= 2
};
